var qt = Object.create;
var F = Object.defineProperty;
var wt = Object.getOwnPropertyDescriptor;
var Et = Object.getOwnPropertyNames;
var xt = Object.getPrototypeOf,
    gt = Object.prototype.hasOwnProperty;
var Pt = (t, e, r) => e in t ? F(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
}) : t[e] = r;
var d = (t, e) => () => (e || t((e = {
    exports: {}
}).exports, e), e.exports);
var Ct = (t, e, r, i) => {
    if (e && typeof e == "object" || typeof e == "function")
        for (let n of Et(e)) !gt.call(t, n) && n !== r && F(t, n, {
            get: () => e[n],
            enumerable: !(i = wt(e, n)) || i.enumerable
        });
    return t
};
var Rt = (t, e, r) => (r = t != null ? qt(xt(t)) : {}, Ct(e || !t || !t.__esModule ? F(r, "default", {
    value: t,
    enumerable: !0
}) : r, t));
var E = (t, e, r) => (Pt(t, typeof e != "symbol" ? e + "" : e, r), r);
var V = d((xr, ce) => {
    "use strict";
    ce.exports = function(e, r) {
        return function() {
            for (var n = new Array(arguments.length), s = 0; s < n.length; s++) n[s] = arguments[s];
            return e.apply(r, n)
        }
    }
});
var m = d((gr, fe) => {
    "use strict";
    var Tt = V(),
        x = Object.prototype.toString;

    function J(t) {
        return x.call(t) === "[object Array]"
    }

    function k(t) {
        return typeof t == "undefined"
    }

    function At(t) {
        return t !== null && !k(t) && t.constructor !== null && !k(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t)
    }

    function Ot(t) {
        return x.call(t) === "[object ArrayBuffer]"
    }

    function Lt(t) {
        return typeof FormData != "undefined" && t instanceof FormData
    }

    function Nt(t) {
        var e;
        return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && t.buffer instanceof ArrayBuffer, e
    }

    function Ut(t) {
        return typeof t == "string"
    }

    function _t(t) {
        return typeof t == "number"
    }

    function le(t) {
        return t !== null && typeof t == "object"
    }

    function _(t) {
        if (x.call(t) !== "[object Object]") return !1;
        var e = Object.getPrototypeOf(t);
        return e === null || e === Object.prototype
    }

    function Bt(t) {
        return x.call(t) === "[object Date]"
    }

    function It(t) {
        return x.call(t) === "[object File]"
    }

    function Dt(t) {
        return x.call(t) === "[object Blob]"
    }

    function de(t) {
        return x.call(t) === "[object Function]"
    }

    function jt(t) {
        return le(t) && de(t.pipe)
    }

    function Mt(t) {
        return typeof URLSearchParams != "undefined" && t instanceof URLSearchParams
    }

    function Ht(t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "")
    }

    function Ft() {
        return typeof navigator != "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined"
    }

    function W(t, e) {
        if (!(t === null || typeof t == "undefined"))
            if (typeof t != "object" && (t = [t]), J(t))
                for (var r = 0, i = t.length; r < i; r++) e.call(null, t[r], r, t);
            else
                for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.call(null, t[n], n, t)
    }

    function $() {
        var t = {};

        function e(n, s) {
            _(t[s]) && _(n) ? t[s] = $(t[s], n) : _(n) ? t[s] = $({}, n) : J(n) ? t[s] = n.slice() : t[s] = n
        }
        for (var r = 0, i = arguments.length; r < i; r++) W(arguments[r], e);
        return t
    }

    function Vt(t, e, r) {
        return W(e, function(n, s) {
            r && typeof n == "function" ? t[s] = Tt(n, r) : t[s] = n
        }), t
    }

    function kt(t) {
        return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t
    }
    fe.exports = {
        isArray: J,
        isArrayBuffer: Ot,
        isBuffer: At,
        isFormData: Lt,
        isArrayBufferView: Nt,
        isString: Ut,
        isNumber: _t,
        isObject: le,
        isPlainObject: _,
        isUndefined: k,
        isDate: Bt,
        isFile: It,
        isBlob: Dt,
        isFunction: de,
        isStream: jt,
        isURLSearchParams: Mt,
        isStandardBrowserEnv: Ft,
        forEach: W,
        merge: $,
        extend: Vt,
        trim: Ht,
        stripBOM: kt
    }
});
var z = d((Pr, pe) => {
    "use strict";
    var P = m();

    function he(t) {
        return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]")
    }
    pe.exports = function(e, r, i) {
        if (!r) return e;
        var n;
        if (i) n = i(r);
        else if (P.isURLSearchParams(r)) n = r.toString();
        else {
            var s = [];
            P.forEach(r, function(c, y) {
                c === null || typeof c == "undefined" || (P.isArray(c) ? y = y + "[]" : c = [c], P.forEach(c, function(l) {
                    P.isDate(l) ? l = l.toISOString() : P.isObject(l) && (l = JSON.stringify(l)), s.push(he(y) + "=" + he(l))
                }))
            }), n = s.join("&")
        }
        if (n) {
            var a = e.indexOf("#");
            a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + n
        }
        return e
    }
});
var ye = d((Cr, me) => {
    "use strict";
    var $t = m();

    function B() {
        this.handlers = []
    }
    B.prototype.use = function(e, r, i) {
        return this.handlers.push({
            fulfilled: e,
            rejected: r,
            synchronous: i ? i.synchronous : !1,
            runWhen: i ? i.runWhen : null
        }), this.handlers.length - 1
    };
    B.prototype.eject = function(e) {
        this.handlers[e] && (this.handlers[e] = null)
    };
    B.prototype.forEach = function(e) {
        $t.forEach(this.handlers, function(i) {
            i !== null && e(i)
        })
    };
    me.exports = B
});
var Se = d((Rr, ve) => {
    "use strict";
    var Jt = m();
    ve.exports = function(e, r) {
        Jt.forEach(e, function(n, s) {
            s !== r && s.toUpperCase() === r.toUpperCase() && (e[r] = n, delete e[s])
        })
    }
});
var X = d((Tr, be) => {
    "use strict";
    be.exports = function(e, r, i, n, s) {
        return e.config = r, i && (e.code = i), e.request = n, e.response = s, e.isAxiosError = !0, e.toJSON = function() {
            return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
                status: this.response && this.response.status ? this.response.status : null
            }
        }, e
    }
});
var K = d((Ar, qe) => {
    "use strict";
    var Wt = X();
    qe.exports = function(e, r, i, n, s) {
        var a = new Error(e);
        return Wt(a, r, i, n, s)
    }
});
var Ee = d((Or, we) => {
    "use strict";
    var zt = K();
    we.exports = function(e, r, i) {
        var n = i.config.validateStatus;
        !i.status || !n || n(i.status) ? e(i) : r(zt("Request failed with status code " + i.status, i.config, null, i.request, i))
    }
});
var ge = d((Lr, xe) => {
    "use strict";
    var I = m();
    xe.exports = I.isStandardBrowserEnv() ? function() {
        return {
            write: function(r, i, n, s, a, u) {
                var c = [];
                c.push(r + "=" + encodeURIComponent(i)), I.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()), I.isString(s) && c.push("path=" + s), I.isString(a) && c.push("domain=" + a), u === !0 && c.push("secure"), document.cookie = c.join("; ")
            },
            read: function(r) {
                var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
                return i ? decodeURIComponent(i[3]) : null
            },
            remove: function(r) {
                this.write(r, "", Date.now() - 864e5)
            }
        }
    }() : function() {
        return {
            write: function() {},
            read: function() {
                return null
            },
            remove: function() {}
        }
    }()
});
var Ce = d((Nr, Pe) => {
    "use strict";
    Pe.exports = function(e) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)
    }
});
var Te = d((Ur, Re) => {
    "use strict";
    Re.exports = function(e, r) {
        return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e
    }
});
var Oe = d((_r, Ae) => {
    "use strict";
    var Xt = Ce(),
        Kt = Te();
    Ae.exports = function(e, r) {
        return e && !Xt(r) ? Kt(e, r) : r
    }
});
var Ne = d((Br, Le) => {
    "use strict";
    var G = m(),
        Gt = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
    Le.exports = function(e) {
        var r = {},
            i, n, s;
        return e && G.forEach(e.split(`
`), function(u) {
            if (s = u.indexOf(":"), i = G.trim(u.substr(0, s)).toLowerCase(), n = G.trim(u.substr(s + 1)), i) {
                if (r[i] && Gt.indexOf(i) >= 0) return;
                i === "set-cookie" ? r[i] = (r[i] ? r[i] : []).concat([n]) : r[i] = r[i] ? r[i] + ", " + n : n
            }
        }), r
    }
});
var Be = d((Ir, _e) => {
    "use strict";
    var Ue = m();
    _e.exports = Ue.isStandardBrowserEnv() ? function() {
        var e = /(msie|trident)/i.test(navigator.userAgent),
            r = document.createElement("a"),
            i;

        function n(s) {
            var a = s;
            return e && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
                href: r.href,
                protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
                host: r.host,
                search: r.search ? r.search.replace(/^\?/, "") : "",
                hash: r.hash ? r.hash.replace(/^#/, "") : "",
                hostname: r.hostname,
                port: r.port,
                pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
            }
        }
        return i = n(window.location.href),
            function(a) {
                var u = Ue.isString(a) ? n(a) : a;
                return u.protocol === i.protocol && u.host === i.host
            }
    }() : function() {
        return function() {
            return !0
        }
    }()
});
var O = d((Dr, Ie) => {
    "use strict";

    function Y(t) {
        this.message = t
    }
    Y.prototype.toString = function() {
        return "Cancel" + (this.message ? ": " + this.message : "")
    };
    Y.prototype.__CANCEL__ = !0;
    Ie.exports = Y
});
var Z = d((jr, De) => {
    "use strict";
    var D = m(),
        Yt = Ee(),
        Qt = ge(),
        Zt = z(),
        er = Oe(),
        tr = Ne(),
        rr = Be(),
        Q = K(),
        nr = L(),
        ir = O();
    De.exports = function(e) {
        return new Promise(function(i, n) {
            var s = e.data,
                a = e.headers,
                u = e.responseType,
                c;

            function y() {
                e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c)
            }
            D.isFormData(s) && delete a["Content-Type"];
            var o = new XMLHttpRequest;
            if (e.auth) {
                var l = e.auth.username || "",
                    h = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
                a.Authorization = "Basic " + btoa(l + ":" + h)
            }
            var w = er(e.baseURL, e.url);
            o.open(e.method.toUpperCase(), Zt(w, e.params, e.paramsSerializer), !0), o.timeout = e.timeout;

            function T() {
                if (o) {
                    var p = "getAllResponseHeaders" in o ? tr(o.getAllResponseHeaders()) : null,
                        q = !u || u === "text" || u === "json" ? o.responseText : o.response,
                        S = {
                            data: q,
                            status: o.status,
                            statusText: o.statusText,
                            headers: p,
                            config: e,
                            request: o
                        };
                    Yt(function(g) {
                        i(g), y()
                    }, function(g) {
                        n(g), y()
                    }, S), o = null
                }
            }
            if ("onloadend" in o ? o.onloadend = T : o.onreadystatechange = function() {
                    !o || o.readyState !== 4 || o.status === 0 && !(o.responseURL && o.responseURL.indexOf("file:") === 0) || setTimeout(T)
                }, o.onabort = function() {
                    o && (n(Q("Request aborted", e, "ECONNABORTED", o)), o = null)
                }, o.onerror = function() {
                    n(Q("Network Error", e, null, o)), o = null
                }, o.ontimeout = function() {
                    var q = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded",
                        S = e.transitional || nr.transitional;
                    e.timeoutErrorMessage && (q = e.timeoutErrorMessage), n(Q(q, e, S.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", o)), o = null
                }, D.isStandardBrowserEnv()) {
                var A = (e.withCredentials || rr(w)) && e.xsrfCookieName ? Qt.read(e.xsrfCookieName) : void 0;
                A && (a[e.xsrfHeaderName] = A)
            }
            "setRequestHeader" in o && D.forEach(a, function(q, S) {
                typeof s == "undefined" && S.toLowerCase() === "content-type" ? delete a[S] : o.setRequestHeader(S, q)
            }), D.isUndefined(e.withCredentials) || (o.withCredentials = !!e.withCredentials), u && u !== "json" && (o.responseType = e.responseType), typeof e.onDownloadProgress == "function" && o.addEventListener("progress", e.onDownloadProgress), typeof e.onUploadProgress == "function" && o.upload && o.upload.addEventListener("progress", e.onUploadProgress), (e.cancelToken || e.signal) && (c = function(p) {
                o && (n(!p || p && p.type ? new ir("canceled") : p), o.abort(), o = null)
            }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c))), s || (s = null), o.send(s)
        })
    }
});
var L = d((Mr, He) => {
    "use strict";
    var f = m(),
        je = Se(),
        sr = X(),
        or = {
            "Content-Type": "application/x-www-form-urlencoded"
        };

    function Me(t, e) {
        !f.isUndefined(t) && f.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e)
    }

    function ar() {
        var t;
        return typeof XMLHttpRequest != "undefined" ? t = Z() : typeof process != "undefined" && Object.prototype.toString.call(process) === "[object process]" && (t = Z()), t
    }

    function ur(t, e, r) {
        if (f.isString(t)) try {
            return (e || JSON.parse)(t), f.trim(t)
        } catch (i) {
            if (i.name !== "SyntaxError") throw i
        }
        return (r || JSON.stringify)(t)
    }
    var j = {
        transitional: {
            silentJSONParsing: !0,
            forcedJSONParsing: !0,
            clarifyTimeoutError: !1
        },
        adapter: ar(),
        transformRequest: [function(e, r) {
            return je(r, "Accept"), je(r, "Content-Type"), f.isFormData(e) || f.isArrayBuffer(e) || f.isBuffer(e) || f.isStream(e) || f.isFile(e) || f.isBlob(e) ? e : f.isArrayBufferView(e) ? e.buffer : f.isURLSearchParams(e) ? (Me(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : f.isObject(e) || r && r["Content-Type"] === "application/json" ? (Me(r, "application/json"), ur(e)) : e
        }],
        transformResponse: [function(e) {
            var r = this.transitional || j.transitional,
                i = r && r.silentJSONParsing,
                n = r && r.forcedJSONParsing,
                s = !i && this.responseType === "json";
            if (s || n && f.isString(e) && e.length) try {
                return JSON.parse(e)
            } catch (a) {
                if (s) throw a.name === "SyntaxError" ? sr(a, this, "E_JSON_PARSE") : a
            }
            return e
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        validateStatus: function(e) {
            return e >= 200 && e < 300
        },
        headers: {
            common: {
                Accept: "application/json, text/plain, */*"
            }
        }
    };
    f.forEach(["delete", "get", "head"], function(e) {
        j.headers[e] = {}
    });
    f.forEach(["post", "put", "patch"], function(e) {
        j.headers[e] = f.merge(or)
    });
    He.exports = j
});
var Ve = d((Hr, Fe) => {
    "use strict";
    var cr = m(),
        lr = L();
    Fe.exports = function(e, r, i) {
        var n = this || lr;
        return cr.forEach(i, function(a) {
            e = a.call(n, e, r)
        }), e
    }
});
var ee = d((Fr, ke) => {
    "use strict";
    ke.exports = function(e) {
        return !!(e && e.__CANCEL__)
    }
});
var We = d((Vr, Je) => {
    "use strict";
    var $e = m(),
        te = Ve(),
        dr = ee(),
        fr = L(),
        hr = O();

    function re(t) {
        if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new hr("canceled")
    }
    Je.exports = function(e) {
        re(e), e.headers = e.headers || {}, e.data = te.call(e, e.data, e.headers, e.transformRequest), e.headers = $e.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), $e.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(n) {
            delete e.headers[n]
        });
        var r = e.adapter || fr.adapter;
        return r(e).then(function(n) {
            return re(e), n.data = te.call(e, n.data, n.headers, e.transformResponse), n
        }, function(n) {
            return dr(n) || (re(e), n && n.response && (n.response.data = te.call(e, n.response.data, n.response.headers, e.transformResponse))), Promise.reject(n)
        })
    }
});
var ne = d((kr, ze) => {
    "use strict";
    var v = m();
    ze.exports = function(e, r) {
        r = r || {};
        var i = {};

        function n(o, l) {
            return v.isPlainObject(o) && v.isPlainObject(l) ? v.merge(o, l) : v.isPlainObject(l) ? v.merge({}, l) : v.isArray(l) ? l.slice() : l
        }

        function s(o) {
            if (v.isUndefined(r[o])) {
                if (!v.isUndefined(e[o])) return n(void 0, e[o])
            } else return n(e[o], r[o])
        }

        function a(o) {
            if (!v.isUndefined(r[o])) return n(void 0, r[o])
        }

        function u(o) {
            if (v.isUndefined(r[o])) {
                if (!v.isUndefined(e[o])) return n(void 0, e[o])
            } else return n(void 0, r[o])
        }

        function c(o) {
            if (o in r) return n(e[o], r[o]);
            if (o in e) return n(void 0, e[o])
        }
        var y = {
            url: a,
            method: a,
            data: a,
            baseURL: u,
            transformRequest: u,
            transformResponse: u,
            paramsSerializer: u,
            timeout: u,
            timeoutMessage: u,
            withCredentials: u,
            adapter: u,
            responseType: u,
            xsrfCookieName: u,
            xsrfHeaderName: u,
            onUploadProgress: u,
            onDownloadProgress: u,
            decompress: u,
            maxContentLength: u,
            maxBodyLength: u,
            transport: u,
            httpAgent: u,
            httpsAgent: u,
            cancelToken: u,
            socketPath: u,
            responseEncoding: u,
            validateStatus: c
        };
        return v.forEach(Object.keys(e).concat(Object.keys(r)), function(l) {
            var h = y[l] || s,
                w = h(l);
            v.isUndefined(w) && h !== c || (i[l] = w)
        }), i
    }
});
var ie = d(($r, Xe) => {
    Xe.exports = {
        version: "0.24.0"
    }
});
var Ye = d((Jr, Ge) => {
    "use strict";
    var pr = ie().version,
        se = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
        se[t] = function(i) {
            return typeof i === t || "a" + (e < 1 ? "n " : " ") + t
        }
    });
    var Ke = {};
    se.transitional = function(e, r, i) {
        function n(s, a) {
            return "[Axios v" + pr + "] Transitional option '" + s + "'" + a + (i ? ". " + i : "")
        }
        return function(s, a, u) {
            if (e === !1) throw new Error(n(a, " has been removed" + (r ? " in " + r : "")));
            return r && !Ke[a] && (Ke[a] = !0, console.warn(n(a, " has been deprecated since v" + r + " and will be removed in the near future"))), e ? e(s, a, u) : !0
        }
    };

    function mr(t, e, r) {
        if (typeof t != "object") throw new TypeError("options must be an object");
        for (var i = Object.keys(t), n = i.length; n-- > 0;) {
            var s = i[n],
                a = e[s];
            if (a) {
                var u = t[s],
                    c = u === void 0 || a(u, s, t);
                if (c !== !0) throw new TypeError("option " + s + " must be " + c);
                continue
            }
            if (r !== !0) throw Error("Unknown option " + s)
        }
    }
    Ge.exports = {
        assertOptions: mr,
        validators: se
    }
});
var nt = d((Wr, rt) => {
    "use strict";
    var et = m(),
        yr = z(),
        Qe = ye(),
        Ze = We(),
        M = ne(),
        tt = Ye(),
        C = tt.validators;

    function N(t) {
        this.defaults = t, this.interceptors = {
            request: new Qe,
            response: new Qe
        }
    }
    N.prototype.request = function(e) {
        typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = M(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
        var r = e.transitional;
        r !== void 0 && tt.assertOptions(r, {
            silentJSONParsing: C.transitional(C.boolean),
            forcedJSONParsing: C.transitional(C.boolean),
            clarifyTimeoutError: C.transitional(C.boolean)
        }, !1);
        var i = [],
            n = !0;
        this.interceptors.request.forEach(function(h) {
            typeof h.runWhen == "function" && h.runWhen(e) === !1 || (n = n && h.synchronous, i.unshift(h.fulfilled, h.rejected))
        });
        var s = [];
        this.interceptors.response.forEach(function(h) {
            s.push(h.fulfilled, h.rejected)
        });
        var a;
        if (!n) {
            var u = [Ze, void 0];
            for (Array.prototype.unshift.apply(u, i), u = u.concat(s), a = Promise.resolve(e); u.length;) a = a.then(u.shift(), u.shift());
            return a
        }
        for (var c = e; i.length;) {
            var y = i.shift(),
                o = i.shift();
            try {
                c = y(c)
            } catch (l) {
                o(l);
                break
            }
        }
        try {
            a = Ze(c)
        } catch (l) {
            return Promise.reject(l)
        }
        for (; s.length;) a = a.then(s.shift(), s.shift());
        return a
    };
    N.prototype.getUri = function(e) {
        return e = M(this.defaults, e), yr(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
    };
    et.forEach(["delete", "get", "head", "options"], function(e) {
        N.prototype[e] = function(r, i) {
            return this.request(M(i || {}, {
                method: e,
                url: r,
                data: (i || {}).data
            }))
        }
    });
    et.forEach(["post", "put", "patch"], function(e) {
        N.prototype[e] = function(r, i, n) {
            return this.request(M(n || {}, {
                method: e,
                url: r,
                data: i
            }))
        }
    });
    rt.exports = N
});
var st = d((zr, it) => {
    "use strict";
    var vr = O();

    function R(t) {
        if (typeof t != "function") throw new TypeError("executor must be a function.");
        var e;
        this.promise = new Promise(function(n) {
            e = n
        });
        var r = this;
        this.promise.then(function(i) {
            if (r._listeners) {
                var n, s = r._listeners.length;
                for (n = 0; n < s; n++) r._listeners[n](i);
                r._listeners = null
            }
        }), this.promise.then = function(i) {
            var n, s = new Promise(function(a) {
                r.subscribe(a), n = a
            }).then(i);
            return s.cancel = function() {
                r.unsubscribe(n)
            }, s
        }, t(function(n) {
            r.reason || (r.reason = new vr(n), e(r.reason))
        })
    }
    R.prototype.throwIfRequested = function() {
        if (this.reason) throw this.reason
    };
    R.prototype.subscribe = function(e) {
        if (this.reason) {
            e(this.reason);
            return
        }
        this._listeners ? this._listeners.push(e) : this._listeners = [e]
    };
    R.prototype.unsubscribe = function(e) {
        if (this._listeners) {
            var r = this._listeners.indexOf(e);
            r !== -1 && this._listeners.splice(r, 1)
        }
    };
    R.source = function() {
        var e, r = new R(function(n) {
            e = n
        });
        return {
            token: r,
            cancel: e
        }
    };
    it.exports = R
});
var at = d((Xr, ot) => {
    "use strict";
    ot.exports = function(e) {
        return function(i) {
            return e.apply(null, i)
        }
    }
});
var ct = d((Kr, ut) => {
    "use strict";
    ut.exports = function(e) {
        return typeof e == "object" && e.isAxiosError === !0
    }
});
var ft = d((Gr, oe) => {
    "use strict";
    var lt = m(),
        Sr = V(),
        H = nt(),
        br = ne(),
        qr = L();

    function dt(t) {
        var e = new H(t),
            r = Sr(H.prototype.request, e);
        return lt.extend(r, H.prototype, e), lt.extend(r, e), r.create = function(n) {
            return dt(br(t, n))
        }, r
    }
    var b = dt(qr);
    b.Axios = H;
    b.Cancel = O();
    b.CancelToken = st();
    b.isCancel = ee();
    b.VERSION = ie().version;
    b.all = function(e) {
        return Promise.all(e)
    };
    b.spread = at();
    b.isAxiosError = ct();
    oe.exports = b;
    oe.exports.default = b
});
var pt = d((Yr, ht) => {
    ht.exports = ft()
});
var ue = () => {
    var t, e, r, i, n, s;
    return [{
        id: "main-product",
        section: (t = document.querySelector(".main-product__inner")) == null ? void 0 : t.id,
        selector: ".main-product__product-information"
    }, {
        id: "main-product",
        section: (e = document.querySelector(".main-product__inner")) == null ? void 0 : e.id,
        selector: "#product-media"
    }, {
        id: "main-product",
        section: (r = document.querySelector(".main-product__inner")) == null ? void 0 : r.id,
        selector: "#productDescription"
    }, {
        id: "main-product",
        section: (i = document.querySelector(".main-product__inner")) == null ? void 0 : i.id,
        selector: "#upsellHolder"
    }, {
        id: "lightbox",
        section: (n = document.querySelector("lightbox-component")) == null ? void 0 : n.getAttribute("data-section-id"),
        selector: "#lightboxContentMedia"
    }, {
        id: "lightbox",
        section: (s = document.querySelector("lightbox-component")) == null ? void 0 : s.getAttribute("data-section-id"),
        selector: "#lightboxContentThumbs"
    }]
};
var vt = Rt(pt(), 1);
var mt = (t, e) => {
    if (t) {
        let i = new DOMParser().parseFromString(t, "text/html").querySelector(e);
        if (i) return i.innerHTML;
        console.error(`Element with selector "${e}" not found.`)
    }
};
var yt = (t, e) => {
    e.forEach(r => {
        let i = document.querySelectorAll(r.selector) || document.getElementById(r.id).querySelector(r.selector);
        i !== null && i.forEach(n => {
            n.innerHTML = mt(t[r.section], r.selector)
        })
    })
};
var ae = class extends HTMLElement {
    constructor() {
        super();
        E(this, "handleVariantChange", () => {
            this.mainProductElement.setAttribute("aria-busy", "true"), this.updateOptions(), this.getSelectedVariant(), this.updateURL(), this.renderProductInformation(), this.updateLightbox(), console.log("Variant changed");            
        });
        E(this, "updateOptions", () => {
            let r = Array.from(this.querySelectorAll("fieldset"));
            this.options = r.map(i => Array.from(i.querySelectorAll("input")).find(n => n.checked).value)
        });
        E(this, "getSelectedVariant", () => {
            this.currentVariant = this.getVariantData().find(r => !r.options.map((i, n) => this.options[n] === i).includes(!1))
        });
        E(this, "getVariantData", () => (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData));
        E(this, "updateURL", () => {
            let r = new URL(window.location.href);
            r.searchParams.set("variant", this.currentVariant.id), window.history.replaceState({}, "", `${r.toString()}`)
        });
        E(this, "updateLightbox", () => {
            let r = ue(),
                i = new URL(window.location.href);
            i.searchParams.set("sections", [...new Set(r.map(s => s.section))]);
            let n = document.querySelector(".product-media");
            n && n.classList.add("js-loading");
            try {
                vt.default.get(i).then(s => {
                    let a = s.data;
                    yt(a, r), n && n.classList.remove("js-loading")
                })
            } catch (s) {
                n && n.classList.remove("js-loading")
            } finally {
                let s = new Event("sections:product-media:updated");
                document.dispatchEvent(s)
            }
        });
        E(this, "renderProductInformation", () => {
            let r = new URL(window.location.href);
            r.searchParams.set("variant", this.currentVariant.id), r.searchParams.set("section_id", this.sectionId);
            let i = document.querySelector(`#ProductMedia-${this.sectionId}`);
            try {
                fetch(r).then(n => n.text()).then(n => {
                    let s = new DOMParser().parseFromString(n, "text/html"),
                        a = document.querySelectorAll(`#ProductVariantId-${this.sectionId}`),
                        u = s.querySelectorAll(`#ProductVariantId-${this.sectionId}`);
                    a && u && a.forEach((St, bt) => {
                        St.value = u[bt].value
                    });
                    let c = document.querySelector(".main-product__product-information"),
                        y = s.querySelector(".main-product__product-information");
                    c && y && c.replaceWith(y);
                    let o = s.querySelector(`#ProductMedia-${this.sectionId}`),
                        l = i.getAttribute("data-featured-image"),
                        h = o == null ? void 0 : o.getAttribute("data-featured-image");
                    i && o && l !== h ? i.replaceWith(o) : i.setAttribute("aria-busy", "false");
                    let w = document.querySelector(`#ProductBuyButtons-${this.sectionId}`),
                        T = s.querySelector(`#ProductBuyButtons-${this.sectionId}`);
                    w && T && w.replaceWith(T);
                    let A = document.querySelector(`#ProductVariants-${this.sectionId}`),
                        p = s.querySelector(`#ProductVariants-${this.sectionId}`);
                    A && p && A.replaceWith(p);
                    let q = document.querySelector(`#ProductConnectedTypes-${this.sectionId}`),
                        S = s.querySelector(`#ProductConnectedTypes-${this.sectionId}`);
                    q && S && q.replaceWith(S);
                    let U = document.querySelector(`#ProductUpsell-${this.sectionId}`),
                        g = s.querySelector(`#ProductUpsell-${this.sectionId}`);
                    U && g && U.replaceWith(g), this.mainProductElement.setAttribute("aria-busy", "false");
                    const variantUpdatedEvent = new CustomEvent("variant:updated", {
                        bubbles: true,
                    });
                    document.dispatchEvent(variantUpdatedEvent);
                })
            } catch (n) {
                console.log("Something went wrong"), this.mainProductElement.setAttribute("aria-busy", "false")
            }
        });
        let r = this;
        this.sectionId = r.getAttribute("data-section-id"), this.mainProductElement = document.querySelector(`#${this.sectionId}`), this.addEventListener("change", this.handleVariantChange, !0, {
            passive: !1
        })
    }
};
customElements.get("variant-switcher") === void 0 && customElements.define("variant-switcher", ae);